import React from "react";
import {
  calculateFreeTrialDaysLeft,
  isCoachFreeTrial,
} from "../../utils/user-helpers";
import submit from "submit-form";
import {
  getPermissionNamesByIds,
  getRoleNameById,
  getUserToRequest,
} from "../../views/dashboard/settings/manage-coaches/utils/manage-coaches-utils";
const productTypes = {
  All: "All",
  PULL: "PULL",
  PUSH: "PUSH",
  PRESS: "PRESS",
};
const ProductTabs = ({ productType, locals, isButton }) => {
  const {
    activeUser,
    organizationOwner,
    organizationRoles,
    organizationPermissions: globalOrganizationPermissions = [],
  } = locals;

  const { organizationPermissions = [], organizationId } = activeUser;

  const isExpiredPull =
    isCoachFreeTrial(activeUser) && calculateFreeTrialDaysLeft(activeUser) < 1;

  const userIsCoach = activeUser.permissions.includes("coach");
  const userToRequest = userIsCoach
    ? getUserToRequest(activeUser, organizationOwner)
    : activeUser;
  const { pushAccountInfo: isFe, pressAccountInfo } = userToRequest;

  const userOrganizationPermission =
    organizationPermissions.length > 0
      ? getPermissionNamesByIds(
          globalOrganizationPermissions,
          organizationPermissions
        )
      : [""];
  const userCanAccessToPush =
    (!organizationId && isFe) ||
    (isFe && !!organizationId && userOrganizationPermission.includes("PUSH"));
  const userCanAccessToPress =
    (!organizationId && !!pressAccountInfo) ||
    (isFe && !!organizationId && userOrganizationPermission.includes("PRESS"));
  const loadByProduct = (e, selectedProduct) => {
    e.preventDefault();
    if (selectedProduct === productType) return;

    submit("/actions/refresh", {
      method: "GET",
      body: {
        page: 0,
        productType:
          selectedProduct !== productTypes.All ? selectedProduct : "",
      },
    });
  };
  return (
    <>
      <a
        onClick={(e) => loadByProduct(e, productTypes.All)}
        aria-current={
          productType === productTypes.All || !productType ? true : undefined
        }
        role={isButton ? "button" : undefined}
      >
        All
      </a>
      {!isExpiredPull && (
        <a
          onClick={(e) => loadByProduct(e, productTypes.PULL)}
          aria-current={productType === productTypes.PULL ? true : undefined}
          role={isButton ? "button" : undefined}
        >
          PULL
        </a>
      )}
      {userCanAccessToPush && (
        <a
          onClick={(e) => loadByProduct(e, productTypes.PUSH)}
          aria-current={productType === productTypes.PUSH ? true : undefined}
          role={isButton ? "button" : undefined}
        >
          PUSH
        </a>
      )}
      {userCanAccessToPress && (
        <a
          onClick={(e) => loadByProduct(e, productTypes.PRESS)}
          aria-current={productType === productTypes.PRESS ? true : undefined}
          role={isButton ? "button" : undefined}
        >
          PRESS
        </a>
      )}
    </>
  );
};

export default ProductTabs;
